<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading="loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$datePicker",
					"field": "biztime",
					"title": "目标月份",
					"props": {
						"type": "month",
						"disabled":true
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "code",
					"title": "线上商品ID",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$staff",
					"field": "belongstaffid",
					"title": "负责人",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "basemonthsalesum",
					"title": "保底月销",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":2
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "targetmonthsalesum",
					"title": "预计月销",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":2
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "targetmonthpayTotalByrCnt",
					"title": "预计月买家",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":0
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "targetmonthcharge",
					"title": "预计月花费",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":2
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '目标设置',
				modal_width:600,
				modal_height:500,
				loading:false,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init(){
				this.sourceData = this.data
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					this.loading = true
					if(this.data.id){
						this.$api.BIshopgoodskpi.update(this.data.id,submitData).then(()=>{
							this.loading = false
							this.$emit('success')
							this.modal_cancel()
						})
					}else{
						this.$api.BIshopgoodskpi.save(submitData).then(()=>{
							this.loading = false
							this.$emit('success')
							this.modal_cancel()
						})
					}
					console.log(submitData)
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>